var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-select',{attrs:{"valores":_vm.eixosTotais}})
}
var staticRenderFns = []

export { render, staticRenderFns }